import React, { useState } from "react";
import { useMutation } from "react-query";
import { Button, Form, message } from "antd";
import moment from "moment/moment";
import { AxiosPositionsAPI } from "../Api";
import { PositionAddForm } from "./PositionAddForm";
import ActionsModal from "../../common/components/ActionsModal";
import { onSuccess } from "../../common/components/AreasPositions/RequestSolvers";

const PositionAddModal = ({ reload }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const { mutate } = useMutation(
    ["createPosition"],
    AxiosPositionsAPI.createPosition,
    {
      onError: (error) => {
        error.response.status === 409
          ? message.error("Já existe um cargo com este código!")
          : message.error(
              "Não foi possível realizar a solicitação de criação para o novo cargo!",
            );
      },
      onSuccess: () =>
        onSuccess(
          reload,
          form,
          () => setIsModalOpen(false),
          "Cargo criado com sucesso!",
        ),
    },
  );

  const createPosition = (values) => {
    mutate({
      ...values,
      start_date: moment(values.start_date).format("YYYY-MM-DD"),
    });
  };

  return (
    <>
      <ActionsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        onSubmit={createPosition}
        form={form}
        button={
          <Button
            type="primary"
            onClick={() => setIsModalOpen(true)}
            style={{ marginRight: 20 }}
          >
            + Adicionar cargo
          </Button>
        }
        context={"Adicionar cargo"}
      >
        <PositionAddForm form={form} />
      </ActionsModal>
    </>
  );
};

export default PositionAddModal;
